import { getFeatureConfig } from '@luna/feature-config';
import type { MyProfile } from '@shared/profile';

import type { Contact } from '../ContactDataManagementTypes';
import { ContactFlag, ContactType } from '../ContactDataManagementTypes';

export const isVisible = (
    isPhysicalPerson: boolean = false,
    isMainAddressEditable: boolean = false,
): boolean => {
    if (!getFeatureConfig((c) => c.contactDataManagement.proofOfAddressExternalApplication)) {
        return false;
    }

    if (!isPhysicalPerson) {
        return false;
    }

    if (!isMainAddressEditable) {
        return false;
    }

    return true;
};

export const isPhysicalPerson = (customerSegment?: MyProfile['customerSegment']): boolean =>
    customerSegment === 'PHYSICAL_PERSON';

export const isMainAddressEditable = (contacts: Contact[] = []): boolean => {
    const mainEditableAddress = contacts.find((contact) => {
        return (
            contact.type === ContactType.ADDRESS &&
            contact.flags?.includes(ContactFlag.MAIN_CONTACT) &&
            contact.flags?.includes(ContactFlag.EDITABLE)
        );
    });

    return !!mainEditableAddress;
};
